// extracted by mini-css-extract-plugin
module.exports = {"regionField":"Region_regionField__BCVEG"};